<template>
  <div>
    <a href="" id="fileDownload" ref="fileDownload"></a>
    <input v-show="false" type="file" multiple @change="previewFile" id="file" ref="file" />
    <v-dialog v-model="summaryReport" fullscreen>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="summaryReport = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('views.DataUpload.validationSummaryTitle') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="summaryReport = false">{{ $t('views.DataUpload.close') }}</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <template>
            <v-tabs v-model="currentSummaryTab" class="mt-5">
              <v-tab :disabled="!summaryReportAutomaticValidation.errors">
                <v-icon v-if="currentSummaryTab === 0" color="red" small>mdi-alert-circle</v-icon>
                <v-icon v-else color="gray" small>mdi-alert-circle</v-icon>
                <span>&nbsp;{{ $t('views.DataUpload.criticalErrorsTab') }}</span>
              </v-tab>
              <v-tab :disabled="!summaryReportAutomaticValidation.warnings">
                <v-icon v-if="currentSummaryTab === 1" color="orange" small>mdi-alert</v-icon>
                <v-icon v-else color="gray" small>mdi-alert</v-icon>
                <span>&nbsp;{{ $t('views.DataUpload.warningsTab') }}</span>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="currentSummaryTab">
              <v-tab-item :key="0" :transition="false">
                <v-card flat>
                  <v-card-text>
                    <div v-if="summaryReportFileStructureErrors.length">
                      <div class="overline font-weight-bold">{{ $t('views.DataUpload.fileStructureErrors') }}</div>
                      <ul>
                        <li v-for="(error, index) in summaryReportFileStructureErrors" :key="index">
                          {{ error.description }}
                        </li>
                      </ul>
                    </div>
                    <div v-if="summaryReportColumnErrors.length" class="mt-5">
                      <div class="overline font-weight-bold">{{ $t('views.DataUpload.columnWideDataErrors') }}</div>
                      <ul>
                        <li v-for="(error, index) in summaryReportColumnErrors" :key="index">
                          {{ error.description }}
                        </li>
                      </ul>
                    </div>
                    <div v-if="summaryReportRowErrors.length" class="mt-5">
                      <div class="overline font-weight-bold">{{ $t('views.DataUpload.rowSpecificDataErrors') }}</div>
                      <v-container fluid>
                        <v-row v-for="(error, index) in summaryReportRowErrors" :key="index" no-gutters>
                          <v-col cols="2">
                            <b>[{{
                              /* eslint-disable-next-line */
                              error.rows.length < 50 ? error.rows.length : '50+' }} row{{ error.rows.length > 1 ? 's' : '' }}]</b>
                          </v-col>
                          <v-col cols="7">
                            {{ error.description }}
                          </v-col>
                          <v-col cols="2">
                            <a @click="downloadRowsFile(error)"><v-icon color="gray" small>mdi-file</v-icon>
                              <span> {{ $t('views.DataUpload.affectedRowsList') }}</span><span v-if="error.rows.length === 50"> {{ $t('views.DataUpload.onlyFirst50') }}</span>
                            </a>
                          </v-col>
                        </v-row>
                      </v-container>
                    </div>
                    <div v-if="summaryReportCellErrors.length" class="mt-5">
                      <div class="overline font-weight-bold">{{ $t('views.DataUpload.cellSpecificDataErrors') }}</div>
                      <v-container fluid>
                        <v-row v-for="(error, index) in summaryReportCellErrors" :key="index" no-gutters>
                          <v-col cols="2">
                            <b>[{{
                              /* eslint-disable-next-line */
                              error.cells.length < 50 ? error.cells.length : '50+' }} cell{{ error.cells.length > 1 ? 's' : '' }}]</b>
                          </v-col>
                          <v-col cols="7">
                            {{ error.description }}
                          </v-col>
                          <v-col cols="2">
                            <a @click="downloadCellsFile(error)"><v-icon color="gray" small>mdi-file</v-icon>
                              <span> {{ $t('views.DataUpload.affectedCellsList') }}</span><span v-if="error.cells.length === 50"> {{ $t('views.DataUpload.onlyFirst50') }}</span>
                            </a>
                          </v-col>
                        </v-row>
                      </v-container>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="1" :transition="false">
                <v-card flat>
                  <v-card-text>
                    <div v-if="summaryReportFileStructureWarnings.length">
                      <div class="overline font-weight-bold">{{ $t('views.DataUpload.fileStructureWarnings') }}</div>
                      <ul>
                        <li v-for="(error, index) in summaryReportFileStructureWarnings" :key="index">
                          {{ error.description }}
                        </li>
                      </ul>
                    </div>
                    <div v-if="summaryReportColumnWarnings.length" class="mt-5">
                      <div class="overline font-weight-bold">{{ $t('views.DataUpload.columnWideDataWarnings') }}</div>
                      <ul>
                        <li v-for="(error, index) in summaryReportColumnWarnings" :key="index">
                          {{ error.description }}
                        </li>
                      </ul>
                    </div>
                    <div v-if="summaryReportRowWarnings.length" class="mt-5">
                      <div class="overline font-weight-bold">{{ $t('views.DataUpload.rowSpecificDataWarnings') }}</div>
                      <v-container fluid>
                        <v-row v-for="(error, index) in summaryReportRowWarnings" :key="index" no-gutters>
                          <v-col cols="2">
                            <b>[{{
                            /* eslint-disable-next-line */
                            error.rows.length < 50 ? error.rows.length : '50+' }} row{{ error.rows.length > 1 ? 's' : '' }}]</b>
                          </v-col>
                          <v-col cols="7">
                            {{ error.description }}
                          </v-col>
                          <v-col cols="2">
                            <a @click="downloadRowsFile(error)"><v-icon color="gray" small>mdi-file</v-icon>
                            <span> {{ $t('views.DataUpload.affectedRowsList') }}</span><span v-if="error.rows.length === 50"> {{ $t('views.DataUpload.onlyFirst50') }}</span>
                            </a>
                          </v-col>
                        </v-row>
                      </v-container>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="uploadDialog" width="700" persistent>
      <v-card>
        <v-card-title
          class="grey lighten-2"
          primary-title
        >
          {{ $t('views.DataUpload.uploadingFile') }} {{ !!currentFile ? currentFile.name : '' }}
        </v-card-title>
        <v-card-text v-if="!!currentFile && !! uploadFileProgress">
          <v-progress-linear v-model="uploadFileProgress.percent" height="25" reactive class="mt-5">
            <strong>{{ uploadFileProgress.percent }}% ({{ `${fileSizeToString(uploadFileProgress.size)}/${fileSizeToString(currentFile.size)}` }})</strong>
          </v-progress-linear>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="uploadFileProgress.task.cancel(); uploadDialog = false"
          >
            {{ $t('views.DataUpload.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showInstructions" class="mx-auto mb-5 mt-5" width="90%" density="comfortable" type="info" text border="left" color="primary">
      <v-card>
        <v-card-title
          class="grey lighten-2"
          primary-title
        >
          {{ $t('views.DataUpload.instructionsTitle') }}
        </v-card-title>
        <v-card-text>
          <div class="mt-4">
            <h2>{{ $t('views.DataUpload.instructionsHeader') }}</h2>
            <p>{{ $t('views.DataUpload.instructionsIntro') }}</p>
            <ol>
              <li>{{ $t('views.DataUpload.instructionsStep1') }}</li>
              <li>{{ $t('views.DataUpload.instructionsStep2') }}</li>
              <li>{{ $t('views.DataUpload.instructionsStep3') }}</li>
            </ol>
            <br>
            <p>{{ $t('views.DataUpload.instructionsValidation') }} <v-icon color="green" small>mdi-check-bold</v-icon> {{ $t('views.DataUpload.instructionsValidationContinue') }}</p>
            <p>{{ $t('views.DataUpload.instructionsIfFails') }} <b>"{{ $t('views.DataUpload.summaryReport') }}"</b> {{ $t('views.DataUpload.instructionsReviewDetails') }}</p>
            <ol>
              <li><v-icon color="red" small>mdi-alert-circle</v-icon><b> {{ $t('views.DataUpload.criticalErrorsTab') }}</b> {{ $t('views.DataUpload.criticalErrorsDescription') }}</li>
              <li><v-icon color="orange" small>mdi-alert</v-icon><b> {{ $t('views.DataUpload.warningsTab') }}</b> {{ $t('views.DataUpload.warningsDescription') }}</li>
            </ol>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="showInstructions = false"
          >
            {{ $t('views.DataUpload.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dataCheckDialog" max-width="520">
      <v-card>
        <v-card-text class="pt-6 pb-2 text-center">
          <v-icon size="56" color="primary">mdi-table-eye</v-icon>
          <div class="text-h6 mt-3">{{ $t('views.DataUpload.dataCheckDialogTitle') }}</div>
          <div class="body-2 grey--text text--darken-1 mt-2">{{ $t('views.DataUpload.dataCheckDialogText') }}</div>
        </v-card-text>
        <v-card-actions class="pb-4 px-6">
          <v-spacer></v-spacer>
          <v-btn text @click="dataCheckDialog = false">{{ $t('views.DataUpload.dataCheckDialogLater') }}</v-btn>
          <v-btn color="#212121" class="white--text" @click="goToDataCheck">
            <v-icon left color="primary">mdi-table-eye</v-icon>{{ $t('views.DataUpload.dataCheckDialogGo') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card class="mx-auto mb-5 mt-5" width="90%">
      <v-container fluid>
        <v-row>
          <v-col cols="8" class="text-h6">
            📄 {{ $t('views.DataUpload.dataBriefsUploadTitle') }}
            <div class="caption">{{ $t('views.DataUpload.dataBriefsCaption1') }} <a href="https://firebasestorage.googleapis.com/v0/b/ngapp5-dev.appspot.com/o/public%2FNoiseGrasp%20Brief%20Template.docx?alt=media" download>{{ $t('views.DataUpload.dataBriefsCaption1Link') }}</a>.</div>
            <div class="caption">{{ $t('views.DataUpload.dataBriefsCaption2') }}</div>
          </v-col>
          <v-col cols="4">
            <div class="float-right text-h6">
              <div>
                <div class="d-flex justify-center">
                  {{ $t('views.DataUpload.approvalStatus') }}
                </div>
                <div v-if="approvedBrief">
                  <div class="d-flex justify-center">
                    <v-icon large color="green">mdi-thumb-up</v-icon>
                  </div>
                  <div class="d-flex justify-center caption">
                    {{ toDateTime(approvedBrief.approvedDate) }}
                  </div>
                  <div class="d-flex justify-center caption">
                    {{ approvedBrief.approvedBy }}
                  </div>
                </div>
                <div v-else>
                  <div class="d-flex justify-center overline">
                    {{ $t('views.DataUpload.pending') }}
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="currentClientDataBriefs.length > 0">
          <v-col cols="1" class="text-subtitle-2 d-flex justify-center">{{ $t('views.DataUpload.dataBriefHeader') }}</v-col>
          <v-col cols="2" class="text-subtitle-2">{{ $t('views.DataUpload.uploadedOnHeader') }}</v-col>
          <v-col cols="3" class="text-subtitle-2">{{ $t('views.DataUpload.uploaderHeader') }}</v-col>
          <v-col cols="3" class="text-subtitle-2">{{ $t('views.DataUpload.actionsHeader') }}</v-col>
        </v-row>
        <v-row v-else>
          <v-col>
            <div class="pl-5" style="color: #BDBDBD">{{ $t('views.DataUpload.pleaseUploadDataBrief') }}</div>
          </v-col>
        </v-row>
        <v-row v-for="(dataBrief, index) in sortedDataBriefs" :key="index">
          <v-col cols="1" class="d-flex justify-center">
            <v-btn icon x-small @click="downloadFile(dataBrief.path)">
              <v-icon class="align-center">mdi-file-document-outline</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="2">{{ toDateTime(dataBrief.dateUploaded) }}</v-col>
          <v-col cols="3">{{ dataBrief.uploadedBy }}</v-col>
          <v-col cols="3">
            <a v-if="dataBrief.approved" @click="approveBrief(dataBrief.name, false)"><v-icon color="green">mdi-thumb-up</v-icon><span> {{ $t('views.DataUpload.approveBrief') }}</span></a>
            <a v-else @click="approveBrief(dataBrief.name, true)"><v-icon>mdi-thumb-up</v-icon><span> {{ $t('views.DataUpload.approveBrief') }}</span></a>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="d-flex justify-center mt-5">
              <v-btn small color="#212121" class="white--text" @click="selectDataBrief">
                <v-icon class="align-center" color="primary">mdi-upload</v-icon>
                <span class="pl-2">{{ $t('views.DataUpload.uploadDataBrief') }}</span>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-card class="mx-auto mb-5 mt-5" width="90%">
      <v-container fluid>
        <v-row>
          <v-col cols="8" class="text-h6">
            🗂️ {{ $t('views.DataUpload.dataTemplatesUploadTitle') }}
            <div class="caption">{{ $t('views.DataUpload.dataTemplatesCaption1') }} <a href="https://firebasestorage.googleapis.com/v0/b/ngapp5-dev.appspot.com/o/public%2FNoiseGrasp%20Data%20Template.xlsx?alt=media" download>{{ $t('views.DataUpload.dataBriefsCaption1Link') }}</a>.</div>
            <div class="caption">{{ $t('views.DataUpload.dataTemplatesCaption2') }} <a style="text-decoration-line: underline;" @click="showInstructions = true">{{ $t('views.DataUpload.dataBriefsCaption1Link') }}</a>.</div>
          </v-col>
          <v-col cols="4">
            <div class="float-right text-h6">
              <div>
                <div class="d-flex justify-center">
                  {{ $t('views.DataUpload.approvalStatus') }}
                </div>
                <div v-if="approvedFile">
                  <div class="d-flex justify-center">
                    <v-icon large color="green">mdi-thumb-up</v-icon>
                  </div>
                  <div class="d-flex justify-center caption">
                    {{ toDateTime(approvedFile.approvedDate) }}
                  </div>
                  <div class="d-flex justify-center caption">
                    {{ approvedFile.approvedBy }}
                  </div>
                </div>
                <div v-else>
                  <div class="d-flex justify-center overline">
                    {{ $t('views.DataUpload.pending') }}
                  </div>
                </div>
              </div>
            </div>
        </v-col>
        </v-row>
        <v-row v-if="currentClientDataFiles.length > 0">
          <v-col cols="1" class="text-subtitle-2 d-flex justify-center">{{ $t('views.DataUpload.dataFileHeader') }}</v-col>
          <v-col cols="2" class="text-subtitle-2">{{ $t('views.DataUpload.uploadedOnHeader') }}</v-col>
          <v-col cols="3" class="text-subtitle-2">{{ $t('views.DataUpload.uploaderHeader') }}</v-col>
          <v-col cols="2" class="text-subtitle-2">{{ $t('views.DataUpload.validationResultsHeader') }}</v-col>
          <v-col cols="3" class="text-subtitle-2">{{ $t('views.DataUpload.actionsHeader') }}</v-col>
        </v-row>
        <v-row v-else>
          <v-col>
            <div class="pl-5" style="color: #BDBDBD">{{ $t('views.DataUpload.pleaseUploadData') }}</div>
          </v-col>
        </v-row>
        <v-row v-for="(dataFile, index) in sortedDataFiles" :key="index">
          <v-col cols="1" class="d-flex justify-center">
            <v-btn icon x-small @click="downloadFile(dataFile.path)">
              <v-icon class="align-center">mdi-cloud-download-outline</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="2">{{ toDateTime(dataFile.dateUploaded) }}</v-col>
          <v-col cols="3">{{ dataFile.uploadedBy }}</v-col>
          <v-col cols="2">
            <div v-show="!dataFile.automaticValidation">
              <v-progress-circular v-show="!dataFile.automaticValidation" indeterminate color="primary" size="20"></v-progress-circular>
              <span> {{ $t('views.DataUpload.validatingFile') }}</span>
            </div>
            <div v-if="dataFile && dataFile.automaticValidation && !dataFile.automaticValidation.errors && !dataFile.automaticValidation.warnings">
              <v-icon color="green">mdi-check-bold</v-icon>
              <span> {{ $t('views.DataUpload.noErrorsFound') }}</span>
            </div>
            <div v-if="dataFile.automaticValidation && dataFile.automaticValidation.errors">
              <a @click="showSummaryReport(dataFile)">
                <v-icon color="red">mdi-alert-circle</v-icon>
                <span> {{ $t('views.DataUpload.summaryReport') }}</span>
              </a>
            </div>
            <div v-else-if="dataFile.automaticValidation && !dataFile.automaticValidation.errors && dataFile.automaticValidation.warnings">
              <a @click="showSummaryReport(dataFile)">
                <v-icon color="orange">mdi-alert</v-icon>
                <span> {{ $t('views.DataUpload.summaryReport') }}</span>
              </a>
            </div>
            <div v-if="dataFile.automaticValidation && dataFile.automaticValidation.errors">
              <v-icon small class="ml-1" color="red">mdi-alert-circle-outline</v-icon>
              <span class="caption"> {{ dataFile.automaticValidation.errors.length }} {{ dataFile.automaticValidation.errors.length > 1 ? $t('views.DataUpload.criticalErrors') : $t('views.DataUpload.criticalError') }}</span>
            </div>
            <div v-if="dataFile.automaticValidation && dataFile.automaticValidation.warnings">
              <v-icon small class="ml-1" color="orange">mdi-alert-outline</v-icon>
              <span class="caption"> {{ dataFile.automaticValidation.warnings.length }} {{ dataFile.automaticValidation.warnings.length > 1 ? $t('views.DataUpload.warnings') : $t('views.DataUpload.warning') }}</span>
            </div>
          </v-col>
          <!--v-col cols="2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-if="dataFile.manualValidation" color="green" v-on="on">mdi-check-bold</v-icon>
                <v-icon v-else-if="dataFile.automaticValidation && dataFile.automaticValidation.errors" v-on="on" color="red">mdi-minus-circle</v-icon>
                <v-icon v-else-if="dataFile.automaticValidation && !dataFile.automaticValidation.errors && dataFile.automaticValidation.warnings && !dataFile.dismissWarnings" v-on="on" color="orange">mdi-minus-circle</v-icon>
                <v-icon v-else v-on="on" color="grey lighten-1">mdi-timer-sand</v-icon>
              </template>
              <span v-if="dataFile.manualValidation">Completed</span>
              <span v-else-if="dataFile.automaticValidation && dataFile.automaticValidation.errors">Fix Critical Errors</span>
              <span v-else-if="dataFile.automaticValidation && !dataFile.automaticValidation.errors && dataFile.automaticValidation.warnings && !dataFile.dismissWarnings">Review Warnings</span>
              <span v-else>Pending</span>
            </v-tooltip>
          </v-col-->
          <v-col cols="3">
            <span v-if="dataFile.automaticValidation && dataFile.automaticValidation.errors && dataFile.automaticValidation.errors.length">
              <v-icon color="red">mdi-hand-back-right</v-icon> {{ $t('views.DataUpload.fixErrorsFirst') }}
            </span>
            <span v-else-if="dataFile.automaticValidation && !dataFile.automaticValidation.errors">
             <a v-if="dataFile.approved" @click="approveData(dataFile.name, false)"><v-icon color="green">mdi-thumb-up</v-icon><span> {{ $t('views.DataUpload.approveData') }}</span></a>
             <a v-else @click="approveData(dataFile.name, true)"><v-icon>mdi-thumb-up</v-icon><span> {{ $t('views.DataUpload.approveData') }}</span></a>
            </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="d-flex justify-center mt-5">
            <v-btn small color="#212121" class="white--text" @click="selectDataFile">
              <v-icon class="align-center" color="primary">mdi-upload</v-icon>
              <span class="pl-2">{{ $t('views.DataUpload.uploadFile') }}</span>
            </v-btn>
          </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>
<script>
import numbro from 'numbro'
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      fileName: '',
      fileType: '',
      currentFile: null,
      uploadDialog: false,
      summaryReport: false,
      summaryReportAutomaticValidation: {},
      currentSummaryTab: 0,
      showInstructions: false,
      dataCheckDialog: false
    }
  },
  methods: {
    ...mapActions('storage', [
      'deleteModelFile',
      'editModelFile',
      'uploadFile',
      'resetUploadFileProgress',
      'getFileDownloadUrl'
    ]),
    ...mapActions('clients', [
      'addDataFile',
      'addDataBrief',
      'loadClientDataFiles',
      'loadClientDataBriefs',
      'updateDataFile',
      'updateDataBrief'
    ]),
    showSummaryReport (dataFile) {
      this.summaryReportAutomaticValidation = dataFile.automaticValidation
      if (this.summaryReportAutomaticValidation.errors) {
        this.currentSummaryTab = 0
      } else {
        this.currentSummaryTab = 1
      }
      this.summaryReport = true
    },
    downloadCellsFile (error) {
      // Convert array to CSV string
      const csvContent = 'Cell With Error(s)\n' + error.cells.map(value => value).join('\n')
      // Create a Blob object
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)

      // Create a download link and simulate a click
      const link = document.createElement('a')
      link.setAttribute('href', url)
      link.setAttribute('download', `Affected cells – ${error.description}.csv`)
      document.body.appendChild(link)
      link.click()

      // Clean up
      document.body.removeChild(link)
    },
    downloadRowsFile (error) {
      // Convert array to CSV string
      const csvContent = 'Row Number With Error(s)\n' + error.rows.map(value => value).join('\n')
      // Create a Blob object
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)

      // Create a download link and simulate a click
      const link = document.createElement('a')
      link.setAttribute('href', url)
      link.setAttribute('download', `Affected rows – ${error.description}.csv`)
      document.body.appendChild(link)
      link.click()

      // Clean up
      document.body.removeChild(link)
    },
    toDateTime (dateInt) {
      const dateObj = new Date(dateInt)
      const date = dateObj.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
      const time = dateObj.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false })
      return date + ' – ' + time
    },
    downloadFile (filePath) {
      this.getFileDownloadUrl({
        path: filePath
      }).then(url => {
        this.$refs.fileDownload.href = url
        this.$refs.fileDownload.click()
      })
    },
    triggerAddDataFile (name, path) {
      this.addDataFile({
        client: this.currentClient,
        dataFile: {
          name: name,
          path: path,
          dateUploaded: Date.now(),
          lastActivityDate: Date.now(),
          uploadedBy: `${this.authUser.firstName} ${this.authUser.lastName}`,
          uploaded_by_id: this.authUser.uid
        }
      })
    },
    triggerAddDataBrief (name, path) {
      this.addDataBrief({
        client: this.currentClient,
        dataBrief: {
          name: name,
          path: path,
          dateUploaded: Date.now(),
          lastActivityDate: Date.now(),
          uploadedBy: `${this.authUser.firstName} ${this.authUser.lastName}`,
          uploaded_by_id: this.authUser.uid
        }
      })
    },
    approveData (dataFileName, status) {
      this.updateDataFile({
        name: dataFileName,
        dataFile: {
          approved: status,
          approvedBy: `${this.authUser.firstName} ${this.authUser.lastName}`,
          approvedById: this.authUser.uid,
          approvedDate: Date.now(),
          lastActivityDate: Date.now()
        }
      }).then(() => {
        // Suggest the visual check of the data that was just approved
        if (status) this.dataCheckDialog = true
      })
      if (status && this.approvedFile && this.approvedFile.name !== dataFileName) {
        this.updateDataFile({
          name: this.approvedFile.name,
          dataFile: {
            approved: false,
            approvedBy: `${this.authUser.firstName} ${this.authUser.lastName}`,
            approvedById: this.authUser.uid,
            approvedDate: Date.now(),
            lastActivityDate: Date.now()
          }
        })
      }
    },
    goToDataCheck () {
      this.dataCheckDialog = false
      this.$router.push({ name: 'dataCheck' })
    },
    approveBrief (briefFileName, status) {
      this.updateDataBrief({
        name: briefFileName,
        dataBrief: {
          approved: status,
          approvedBy: `${this.authUser.firstName} ${this.authUser.lastName}`,
          approvedById: this.authUser.uid,
          approvedDate: Date.now(),
          lastActivityDate: Date.now()
        }
      })
      if (status && this.approvedBrief && this.approvedBrief.name !== briefFileName) {
        this.updateDataBrief({
          name: this.approvedBrief.name,
          dataBrief: {
            approved: false,
            approvedBy: `${this.authUser.firstName} ${this.authUser.lastName}`,
            approvedById: this.authUser.uid,
            approvedDate: Date.now(),
            lastActivityDate: Date.now()
          }
        })
      }
    },
    selectDataFile: function () {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      this.$refs.file.value = ''
      this.fileName = `${this.currentClientObject.name}_data_${year}${month}${day}-${hours}${minutes}${seconds}`
      this.fileType = 'data'
      this.$refs.file.click()
    },
    selectDataBrief: function () {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      this.$refs.file.value = ''
      this.fileName = `${this.currentClientObject.name}_brief_${year}${month}${day}-${hours}${minutes}${seconds}`
      this.fileType = 'brief'
      this.$refs.file.click()
    },
    previewFile: function () {
      this.currentFile = this.$refs.file.files[0]
      if (this.fileType === 'report') {
        this.prepareFile({ 'text/html': 'html' }, `/deliverables/${this.currentClient}/`)
      } else if (this.fileType === 'data') {
        this.prepareFile({ 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx' }, `/clientData/${this.currentClient}/${this.authUser.uid}/`)
      } else if (this.fileType === 'brief') {
        this.prepareFile({
          'application/msword': 'doc',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx'
        }, `/clientBriefs/${this.currentClient}/${this.authUser.uid}/`)
      } else {
        console.error('Invalid file type')
      }
    },
    prepareFile: function (allowedFileMimeTypes, targetPath) {
      let fileExtension
      if (allowedFileMimeTypes[this.currentFile.type]) {
        fileExtension = allowedFileMimeTypes[this.currentFile.type]
      } else {
        alert(this.$t('views.DataUpload.unsupportedFileType'))
      }
      if (fileExtension) {
        const fullFileName = `${targetPath}${this.fileName}.${fileExtension}`
        this.triggerUploadFile(this.currentFile, fullFileName).then(() => {
          this.getFileDownloadUrl({
            path: fullFileName
          }).then(url => {
            if (this.fileType === 'data') {
              this.triggerAddDataFile(`${this.fileName}.${fileExtension}`, fullFileName)
            } else if (this.fileType === 'brief') {
              this.triggerAddDataBrief(`${this.fileName}.${fileExtension}`, fullFileName)
            } else {
              console.error('Invalid file type')
            }
          })
        })
      }
    },
    triggerUploadFile: function (file, fileName) {
      return new Promise((resolve, reject) => {
        this.uploadDialog = true
        this.uploadFile({
          file: file,
          path: fileName,
          customMetadata: {
            'uploadedBy': this.authUser.email
          }
        }).then(() => {
          resolve()
        }, error => {
          alert(this.$t('views.DataUpload.errorUploadingFile'))
          reject(error)
        }).finally(() => {
          this.currentFile = null
          this.uploadDialog = false
        })
      })
    },
    fileSizeToString: function (size) {
      return numbro(size).format({
        output: 'byte',
        base: 'binary',
        mantissa: 1
      })
    }
  },
  computed: {
    ...mapGetters('auth', [
      'authUser'
    ]),
    ...mapGetters('storage', [
      'modelFiles',
      'uploadFileProgress'
    ]),
    ...mapGetters('clients', [
      'currentClient',
      'currentClientObject',
      'currentClientDataFiles',
      'currentClientDataBriefs'
    ]),
    summaryReportFileStructureErrors () {
      return _.filter(this.summaryReportAutomaticValidation.errors, error => !error.rows && !error.cells && !error.columns)
    },
    summaryReportColumnErrors () {
      return _.filter(this.summaryReportAutomaticValidation.errors, error => !error.rows && !error.cells && error.columns)
    },
    summaryReportRowErrors () {
      return _.filter(this.summaryReportAutomaticValidation.errors, error => error.rows)
    },
    summaryReportCellErrors () {
      return _.filter(this.summaryReportAutomaticValidation.errors, error => error.cells)
    },
    summaryReportFileStructureWarnings () {
      return _.filter(this.summaryReportAutomaticValidation.warnings, error => !error.rows && !error.columns)
    },
    summaryReportColumnWarnings () {
      return _.filter(this.summaryReportAutomaticValidation.warnings, error => !error.rows && error.columns)
    },
    summaryReportRowWarnings () {
      return _.filter(this.summaryReportAutomaticValidation.warnings, error => error.rows)
    },
    sortedDataFiles () {
      return _.orderBy(this.currentClientDataFiles, ['dateUploaded'], ['asc'])
    },
    sortedDataBriefs () {
      return _.orderBy(this.currentClientDataBriefs, ['dateUploaded'], ['asc'])
    },
    approvedFile () {
      return _.find(this.currentClientDataFiles, dataFile => dataFile.approved)
    },
    approvedBrief () {
      return _.find(this.currentClientDataBriefs, dataBrief => dataBrief.approved)
    }
  },
  components: {},
  created: function () {
    this.loadClientDataFiles(this.currentClient)
    this.loadClientDataBriefs(this.currentClient)
  }
}
</script>
